import 'magnific-popup';

export default function (obj) {
    obj.find('.gallery, .wp-block-gallery').each(function () {
        var gallery = $(this);
        var selector = gallery.hasClass('wp-block-gallery') ? '.blocks-gallery-item a' : '.gallery-icon a.herald-popup';
        $(this).find(selector).magnificPopup({
            type: 'image',
            gallery: {
                enabled: true
            },
            image: {
                titleSrc: function titleSrc(item) {
                    var $caption = gallery.hasClass('wp-block-gallery') ? item.el.closest('figure').find('figcaption') : item.el.closest('.gallery-item').find('.gallery-caption');
                    if ($caption != 'undefined') {
                        return $caption.text();
                    }
                    return '';
                }
            }
        });
    });
}
